/* ax-core.js - shared helpers for the Tienda modules (settings, dates in the shop time zone, holidays, ?ax-date preview).
   Reads <script type="application/json" id="ax-module-settings">; exposes window.AxCore. No storage, no network. */
(() => {
  "use strict";
  const node = document.getElementById("ax-module-settings");
  if (!node) return;
  let S;
  try { S = JSON.parse(node.textContent); } catch { return; }
  const TZ = S.timezone || "America/Merida";
  const pad = (n) => String(n).padStart(2, "0");
  const fmt = (t, vars) => String(t || "").replace(/\{(\w+)\}/g, (m, k) => (k in vars ? vars[k] : m));
  const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
  const zoned = (ms) => Object.fromEntries(new Intl.DateTimeFormat("en-CA", { timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23" })
    .formatToParts(new Date(ms)).filter((x) => x.type !== "literal").map((x) => [x.type, +x.value]));
  const addDays = (d, n) => { const t = new Date(Date.UTC(d.year, d.month - 1, d.day + n)); return { year: t.getUTCFullYear(), month: t.getUTCMonth() + 1, day: t.getUTCDate() }; };
  const H = S.holidays || { days: {}, movable: {}, info: {} };
  const holidayOf = (d) => {
    const wd = new Date(Date.UTC(d.year, d.month - 1, d.day)).getUTCDay();
    const mk = "n" + pad(d.month) + wd + Math.ceil(d.day / 7);
    return (H.movable || {})[mk] || (H.days || {})[pad(d.month) + pad(d.day)] || "";
  };
  // Preview any day: ?ax-date=YYYY-MM-DD (noon in the shop zone). Normal visitors never use it.
  const q = new URLSearchParams(location.search).get("ax-date") || "";
  const shift = /^\d{4}-\d{2}-\d{2}$/.test(q) ? Date.parse(`${q}T12:00:00-06:00`) - Date.now() : 0;
  const now = Date.now() + shift;
  const today = zoned(now);
  const dayOfYear = (d) => Math.round((Date.UTC(d.year, d.month - 1, d.day) - Date.UTC(d.year, 0, 1)) / 86400000) + 1;
  const isoWeek = (d) => {
    const t = new Date(Date.UTC(d.year, d.month - 1, d.day));
    const wd = t.getUTCDay() || 7;
    t.setUTCDate(t.getUTCDate() + 4 - wd);
    return Math.ceil(((t - Date.UTC(t.getUTCFullYear(), 0, 1)) / 86400000 + 1) / 7);
  };
  const secondsToMidnight = () => { const z = zoned(Date.now()); return 86400 - (z.hour * 3600 + z.minute * 60 + z.second); };
  const clock = (s) => `${pad(Math.floor(s / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`;
  window.AxCore = {
    S, TZ, pad, fmt, esc, zoned, addDays, holidayOf, now, shift, today, dayOfYear, isoWeek, secondsToMidnight, clock,
    todayKey: holidayOf(today),
    info: (k) => (H.info || {})[k] || {},
    shopUrl: (path) => `${S.shopBase}${path}${path.includes("?") ? "&" : "?"}${S.utm}`,
  };
})();
